import { render, staticRenderFns } from "./AboutTab.vue?vue&type=template&id=d6b1cb7e&"
import script from "./AboutTab.vue?vue&type=script&lang=js&"
export * from "./AboutTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports